import Axios from 'axios';
import Qs from 'qs';


const modelUrl = "/aliot-laravel/entrance"

export default {


  // 设备管理分页列表
  listPage(
    community_id,
    device_name,
    name,
    page,
    limit
  ) {


    return Axios.get(`${modelUrl}/devicelist`, {
      params: {
        community_id,
        device_name,
        name,
        page,
        limit
      },
      paramsSerializer(params) {
        return Qs.stringify(params);
      }
    })
  },

  // 编辑设备
  edit(
    data
  ) {
    return Axios.post(`${modelUrl}/devicemodify/${data.id}`, data);
  },

  // 读取设备
  info(
    data
  ) {
    return Axios.get(`${modelUrl}/devicedetail/${data.id}`)
  },

  // 添加设备
  add(
    data
  ) {
    return Axios.post(`${modelUrl}/deviceset`, data);
  },

  // 删除设备
  del(
    data
  ) {
    console.log(data)
    return Axios.post(`${modelUrl}/devicedel/${data.id}`);
  },

  // 日志统计
  log(
    community_id,
    device_name,
    name,
    start_time,
    end_time,
    type,
    page,
    limit
  ) {
    return Axios.get(`${modelUrl}/openDoorList`, {
      params: {
        community_id,
        device_name,
        name,
        start_time,
        end_time,
        type,
        page,
        limit
      }
    });
  },

  // 远程开门
  openDoor(
    community_id,
    id
  ) {
    return Axios.post(`/community/api/admin/entrance/open-door/${id}`, {
      community_id
    });
  },

  // 导出
  exportLogList(
    community_id,
    devCode,
    devName,
    start_time,
    end_time,
    unlockStatus,
    deviceType,
    person_type
  ) {
    return Axios.get('/community/api/admin/entrance/unlock-log/export', {
      params: {
        community_id,
        devCode,
        devName,
        start_time,
        end_time,
        unlockStatus,
        deviceType,
        person_type
      },
      responseType: 'blob'
    });
  },
  syncFace(id) {
    return Axios.post(`${modelUrl}/uploadFaceToEntrance/${id}`)
  },
  clearFace(id) {
    return Axios.post(`${modelUrl}/clearFace/${id}`)
  }

}